module.exports = __webpack_public_path__ + "static/media/active-pool.d56c2392.svg";